import styled from 'styled-components';
import { Typography } from '@mui/material';
import colors from '../../../../../../styles/colors';

const Text = styled(Typography)`
  margin-bottom: 5px;
`;

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 16px;
`;

const ActionLabel = styled(Text)`
  font-size: 13px;
  margin-bottom: 10px;
  font-weight: 400;
  color: ${colors.shades.gamma10};
`;

const SettingContainer = styled.div`
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  background-color: ${colors.base.alpha};
`;

export {
  ButtonContainer,
  ActionLabel,
  SettingContainer,
};
